var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: _vm.placement, width: "220" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticStyle: { margin: "16px 0px" } }, [
        _vm._v(
          "\n    This will send a request to the chime to play a sound\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            margin: "0",
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "default" },
              on: {
                click: function ($event) {
                  return _vm.playSound("ding")
                },
              },
            },
            [_vm._v("\n      Play Ding\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.playSound("motion")
                },
              },
            },
            [_vm._v("\n      Play Motion\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { slot: "reference", type: "text" }, slot: "reference" },
        [_vm._v("\n    Play Sounds Test\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }